import React, { useState } from "react";
import { SideBar } from "../component/SideBar";
import MobileNavbar from "../component/MobileNavbar";

const SoulOfMyWorkPage = () => {
  const [showWarning, setShowWarning] = useState(false);

  const handleRightClick = (e) => {
    e.preventDefault();
    setShowWarning(true);
  }
  return (
    <>
      <MobileNavbar />
      <div className="min-h-screen bg-white font-sans text-gray-700 flex justify-center lg:pt-24 sm:pt-5 md:pt-10 pt-5 gap-40">
        <SideBar />
        {
          showWarning && (
            <div className="bg-gray-700" style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: 'white',
              padding: '6px 15px',
              zIndex: 1000,
              fontSize: '10px'
            }}>
              <div className="flex justify-between mb-3">
                <h3 className="font-bold text-md">
                  WARNING
                </h3>
                <button
                  onClick={() => setShowWarning(false)}
                  style={{
                    marginLeft: '10px',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: 'bolder',
                  }}
                >
                  X
                </button>
              </div>
              <span>
                All content is protected by copyright and may not be <br /> downloaded or copied.
              </span>

            </div>
          )
        }
        <div className="w-full max-w-3xl">
          <div className="flex items-start justify-between lg:max-h-[460px] max-h-[75vh] overflow-y-scroll gap-6 p-4 lg:mx-0 md:mx-0 mx-1">
            <div className="text-justify text-[12px] text-base leading-relaxed pr-2">
              <img
                src="/images/soulOfMyWorkPage/01.jpg"
                alt="Art Illustration"
                className="lg:float-right md:float-right float-none h-auto lg:ml-4 md:ml-4 mb-4 lg:w-72 md:w-72 w-full"
                onContextMenu={(e) => {
                  handleRightClick(e)
                }}
              />

              <p>
                I grew up in the eastern part of India where I started painting at
                the age of six. We had a small library in our house which had a
                fairly large collection of books from all over the world. The
                Russian Fairy Tales I had begun taking an interest in came to life
                in my drawings and paintings. This was the beginning of a long
                effort to put my dream world on paper.
              </p>
              <p className="mt-4">
                At the age of seventeen, I left for Santiniketan, a small
                university town in India founded by the eminent literary figure
                Rabindranath Tagore, where I continued my studies in Painting. It
                was a wonder-world for me. The liberating environment of the Fine
                Arts Department, Santiniketan helped me to expand my habit of
                reading good books, watching timeless movies and encouraged me to
                sway by the different kinds of music - I was actually able to
                build a vast range of taste of various art forms that eventually
                made me a flexible person and a flexible artist as a whole.
              </p>
              <p className="mt-4">
                I became fascinated by Surrealism since this form of art is
                characterized by “dream-like” visuals. I developed a strong liking
                for the works of Max Ernst, Rene Magritte, Henry Rousseau, Florine
                Stettheimer and Dorothea Margaret Tanning. Other works, which do
                not directly come from the era of Surrealism, (such as Indian folk
                art and Indian miniature) also influenced me, creating within my
                mind a bridge between real and unreal. I was slowly discovering
                the power of the subconscious mind. The dream, for instance,
                became the ultimate place in my understanding where a human being
                could stitch so many individual thoughts and create a garland.
                This is very much like a movie or a novel, and I developed the
                artistry of “stitching” different thoughts together. No matter
                whether the underlying themes were connected or not, I started
                introducing my own subconscious thoughts into my work. Though the
                characters from the Russian Fairy Tales were not there anymore,
                the narrations of my paintings centred around the many stories of
                my own life and my own subconscious thoughts. The self-reflective
                dialogue of my images became evident and their reality was
                intimately interwoven with my dreams.
              </p>
              <p className="mt-4">
                I already talked about some of the influences but I believe if I
                don't take the names of Frida Kahlo and Bhupen Khakhar – the whole
                story of inspiration would stay imperfect. Frida Kahlo faced a
                terrible bus accident when she was very young and spent much of
                her time in hospitals. As a result, a majority of her paintings
                feature medical imagery and are depicted in terms of anguish and
                hurt, with Kahlo bleeding and showing her open wounds. While in an
                era and setting in India where homosexuality was a significant
                social taboo, Bhupen Khakhar’s open queer theme was exceptional.
                He included his gender identity and struggles in deeply personal
                ways. These two artists taught me how to paint the stories of my
                own life and how to stay honest in terms of expressing the darker
                sides of our lives; they actually made me even more courageous!
              </p>
              <p className="mt-4">
                The images and the colors of the Santiniketan period had depicted
                a world of ecstasy. Once I returned to Kolkata after finishing my
                studies, that world of vivid colors, however, gradually started to
                fade. My detachment from the city Kolkata introduced into my
                paintings a new, pitch-black darkness. I found myself falling into
                the intense darkness of an abyss. I was drifting and floating in
                the dilemma of being attached and detached to the city, thus
                symbolized by the floating images in my work. I also had a kind of
                darkness within myself. There were many lost colorful things -
                people, places, etc that float in this darkness, and that I
                consciously restored in my memory and brought out on my canvas.
                Multiple objects that were more meaningful to me, both visually
                and conceptually, enmeshed the two-dimensional surface of a
                canvas. The black background, which is primarily an emotional
                space, therefore, helped me in giving equal importance to these
                objects.
              </p>
              <p className="mt-4">
                When such content dominated my work, I went for higher studies in
                the Pennsylvania State University, USA. There I decided to develop
                my ideas further through sculpture, photography, and short
                animation along with my canvas paintings to enhance my competency
                in different mediums. This helped me engage with three-
                dimensional space, and as for the themes of my work in sculpture,
                I started looking for objects (e.g., a dragonfly, ducks, etc.)
                from my paintings themselves. Working on the same object on canvas
                as well as in sculpture was like visiting a mountain today and a
                seashore tomorrow! Handling different mediums is such a joy, and
                exhibiting my canvases or photographs or collages or animation
                videos together with my sculptures gives the feelings of thespian
                pursuits in an auditorium - a room of happening!
              </p>
              <p className="mt-4">
                The time when I was handling three-dimensional spaces and multiple
                mediums altogether, I decided to paint my small apartment and it
                was a joyous journey indeed! This project allowed me to go beyond
                the comfort zone of a “safe gallery space” since the walls, the
                dividers, the doors – all made the drawings visually whimsical.
                This venture paves the way for a new path that is “interior
                designing” and “the artist’s grope” continues. This time I was
                largely influenced by the works of Andrew LaMar Hopkins, Yoshitomo
                Nara and Yayoi Kusama.
              </p>
              <p className="mt-4">
                Places always affect my work and myself. My exposure to cultures
                outside India, my interactions with the faculty members at Penn
                State, my peer group, visiting artists at the department, and the
                opportunity to work in an interdisciplinary atmosphere helped me
                grow and understand multiple viewpoints and their reflections on
                art. I love to travel all over the world, and wherever I visit, I
                search for their roots as well as their indigenous form of art.
                This process of imbibing helps me to grow as an artist. My
                teaching experiences at Universities, both in India and the USA,
                also make the armature of my artistic soul stronger. As a person
                who was born and brought up in India, I have now got the opening
                to see the shades of different possibilities such as extracting
                the essence of other continents’ work, practice and vision,
                working in different mediums and making a bridge between them
                through interdisciplinary works, and finally evolving the
                foresight that this whole process is like a meditation where all
                the thoughts converge to make a nest and create a world of heaven.
              </p>
              <div className="flex-1 flex justify-between items-center">
                <img
                  src="/images/soulOfMyWorkPage/03.jpg"
                  alt="Art Illustration"
                  className="max-w-full lg:h-[180px]  md:h-[180px] h-[100px] max-h-[251px] mt-5"
                  onContextMenu={(e) => {
                    handleRightClick(e)
                  }}
                />
                <img
                  src="/images/soulOfMyWorkPage/02.jpg"
                  alt="Art Illustration"
                  className="max-w-full lg:h-[251px] md:h-[251px] h-[130px] max-h-[251px] mt-5"
                  onContextMenu={(e) => {
                    handleRightClick(e)
                  }}
                />
              </div>
            </div>

          </div>

        </div>
      </div>
    </>

  );
};

export default SoulOfMyWorkPage;
